import './App.css';

function App() {
  return (
    <div className="bg-red-500">
      Hello World
    </div>
  );
}

export default App;
